import { ApiError, apiFetch, parseProblem, API_BASE_URL } from "@/lib/api-client";
import { survey } from "@duress/shared";

export async function listClientSurveys(clientId: string): Promise<survey.SurveySendWithResponse[]> {
  const res = await apiFetch(
    `/clients/${encodeURIComponent(clientId)}/surveys`,
    survey.SurveySendListResponseSchema,
  );
  return res.items;
}

export async function createSurveySend(
  clientId: string,
  contactIds: string[],
): Promise<survey.SurveySend> {
  return apiFetch(
    `/clients/${encodeURIComponent(clientId)}/surveys`,
    survey.SurveySendSchema,
    { method: "POST", body: JSON.stringify({ contactIds } satisfies survey.CreateSurveySendRequest) },
  );
}

export async function getSurveyAggregate(
  industryFilter?: string,
): Promise<survey.SurveyAggregate> {
  const qs = industryFilter ? `?industry=${encodeURIComponent(industryFilter)}` : "";
  return apiFetch(`/surveys/results${qs}`, survey.SurveyAggregateSchema);
}

// Public (unauthenticated) — calls /v1/survey/:token directly
export async function getPublicSurveyInfo(token: string): Promise<survey.PublicSurveyInfo> {
  const res = await fetch(`${API_BASE_URL}/v1/survey/${encodeURIComponent(token)}`, {
    credentials: "omit",
  });
  if (!res.ok) {
    throw new ApiError(res.status, await parseProblem(res));
  }
  const json: unknown = await res.json();
  return survey.PublicSurveyInfoSchema.parse(json);
}

export async function submitSurveyResponse(
  token: string,
  data: survey.SubmitSurveyRequest,
): Promise<void> {
  const res = await fetch(`${API_BASE_URL}/v1/survey/${encodeURIComponent(token)}/response`, {
    method: "POST",
    credentials: "omit",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
  if (!res.ok) {
    throw new ApiError(res.status, await parseProblem(res));
  }
}
